import { Text, View } from '@react-pdf/renderer';
import { Table, TableColumn, TableRow, styles, TableCell } from '.';
import { FarData } from '../../../../models/Far';
import {capitalize, getTextByCurrentLanguage} from '../../../../utils/functions';
import { CheckIconSVG } from './CheckIconSvg';
import { CrossIconSvg } from './CrossIconSvg';
import { useTranslation } from "react-i18next";

const columnRatio = ["18%", "82%"];

// it's hardcoded but what can you do ..
function breakString(text: string) {
    // const maxLettersLenght = 13;
    // the 13 in the regular expression represents the number of characters each word should have
    return text.match(/.{1,13}(\s|$)/g);
}

export const CompactTable = (props: {
    data: FarData[]
}) => {
    const { t } = useTranslation();
    const { data } = props;
    if (data.length === 0) {
        return <View></View>
    }
    return <Table wrap>
        <TableRow style={{
            backgroundColor: "#EFF1F5",
            minHeight: "35px",
        }}>
            <TableColumn style={{
                width: columnRatio[0],
                borderLeft: 0,
            }}>
                <TableCell>
                    <Text style={styles.text}>
                        {t("FAR_TableUnitName")}
                    </Text>
                </TableCell>
            </TableColumn>
            <TableColumn style={{
                width: columnRatio[1],
            }}>
                <TableCell>
                    <Text style={styles.text}>
                        {t("FAR_TableDescription")}
                    </Text>
                </TableCell>
            </TableColumn>
        </TableRow>
        {data.filter(r => r.accessibilities.length !== 0).map((r, i) => {
            return <TableRow key={r + i.toString()} style={{
                borderBottom: i === data.length - 1 ? 0 : styles.tableRow.borderBottom,
                display: "flex",
            }}>
                {/* for title */}
                <TableColumn style={{
                    borderLeft: i === 0 ? 0 : "auto",
                    width: columnRatio[0],
                    backgroundColor: "#EDF5FF",
                }}>
                    <TableCell>
                        {breakString(getTextByCurrentLanguage(r.name))?.map((word, i) => <Text key={word + i} style={{
                            ...styles.text,
                            fontWeight: "bold",
                        }}>
                            {word}
                        </Text>)}
                    </TableCell>
                </TableColumn>
                <TableColumn style={{
                    width: columnRatio[1],
                    flexGrow: 1,
                    display: "flex",
                }}>

                    {r.accessibilities.map((a11yData, j) => {
                        const rowHeight = "50px";
                        return <TableRow break={false} key={a11yData.attribute_title + j.toString()} style={{
                            borderBottom: j === r.accessibilities.length - 1 ? 0 : styles.tableRow.borderBottom,
                            backgroundColor: "#FFFFFF",
                            flexGrow: 1,
                        }}>
                            <TableColumn style={{
                                borderLeft: j === 0 ? 0 : "auto",
                                width: "84%",
                                padding: 10,
                                display: "flex",
                                justifyContent: "center",
                            }}>
                                <TableCell style={{
                                    margin: 0,
                                    padding: 0,
                                    display: "flex",
                                    justifyContent: "center",
                                }}>

                                    <Text style={styles.text}>
                                        <Text style={{
                                            ...styles.text,
                                            fontWeight: "bold",
                                        }}>
                                            {a11yData.item_title}
                                        </Text>
                                        : {a11yData.attribute_title}
                                    </Text>
                                </TableCell>
                            </TableColumn>
                            {/* is not absent ( answer is YES ) */}
                            <TableColumn style={{
                                width: "8%",
                            }}>
                                <TableCell >
                                    {!a11yData.is_absent ? <CheckIconSVG color="#5ECC87" /> : <CheckIconSVG />}
                                </TableCell>
                            </TableColumn>
                            {/* is absent (meaning answer is NO) */}
                            <TableColumn style={{
                                width: "8%",
                            }}>
                                <TableCell >
                                    {a11yData.is_absent ? <CrossIconSvg color="#EB5757" /> : <CrossIconSvg />}
                                </TableCell>
                            </TableColumn>
                        </TableRow>
                    })}
                </TableColumn>
            </TableRow>
        })}
    </Table>
}